module.exports = __webpack_public_path__ + "img/玉蘭貞潔_四方連續_彩稿.3e5a53eb.png";